<template>
  <div style="heigh1: calc(-180px + 100vh)">
    <div style="height1: calc(-212px + 100vh); height: 733px; overflow: auto; backgroung-color: green" class="pa-0 mb-3">
      <Message v-for="(el, i) in oldMessages" :key="el.id" :item="el" @click="onClickMessage(el, $event)" />
      <div v-if="newMessages.length" ref="newLabel" class="new-messages-label vac-card-info vac-card-date">Новые сообщения</div>
      <Message v-for="(el, i) in newMessages" :key="el.id" :item="el" v-intersection="() => onMessageVisible(el)" @click="onClickMessage(el, $event)" />
    </div>
    <div class="">
      <v-textarea
        v-model="messageText"
        outlined
        dense
        rows="1"
        auto-grow
        flat
        rounded
        filled
        no-resize
        hide-details
        class="reply-message-field"
        placeholder="Введите текст сообщения"
      ></v-textarea>
    </div>
  </div>
</template>

<script>
import { getAccess, doubleClickDetect } from "@/components/mixings";
export default {
  mixins: [getAccess, doubleClickDetect],
  components: {
    Message: () => import("./ChatMessageItem"),
  },
  props: {
    user_id: Number,
    id: Number,
    needUpdate: Number,
    targetName: String,
  },
  data() {
    return {
      loading: false,
      title: "",
      target: { name: this.targetName },
      data: [],
      messageText: "",

      url: "/mechti/chats_message",
      defaults: {
        sort1: { key: "createdon", order: "asc" },
        filters: { chat_id: this.id },
      },
    };
  },
  created() {
    this.fitchData();
    this.$nextTick(() => {
      if (this.$refs.newLabel) {
        this.$refs.newLabel.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  },
  mounted() {},

  computed: {
    oldMessages() {
      return this.data.filter((d) => d.viewed == 1);
    },

    newMessages() {
      return this.data.filter((d) => d.viewed == 0);
    },
    newComment() {
      return this.$store.getters["state/getNewComment"];
    },
    mess() {
      if (!this.messages) return [];
      return this.messages.sort((a, b) => {
        return (a.date > b.date) - (a.date < b.date);
      });
    },
  },
  watch: {},

  methods: {
    onMessageVisible(el) {
      // Помечаем сообщение как прочитанное, если оно отображено на экране
      if (el.viewed !== 1) {
        this.markAsRead(el);
      }
    },
    markAsRead(message) {
      // Логика отметки сообщения как прочитанного
      // Здесь можно выполнить запрос к серверу для отметки прочитанного сообщения
      console.log("read", message, message.viewed);
      message.viewed = 1;
    },
    checkNewComment(data) {
      console.log("checkNewComment", data);
      this.fitchData();
    },
    async fitchData() {
      this.loading = true;

      const d = await this.$axios.get(this.url, { params: this.defaults });
      if (d.data && d.data.data) {
        this.data = d.data.data;
      }
      this.loading = !true;
    },
    onClickMenu(item) {
      if (item.action) item.action(this.currentComment);
    },
    onSingleClick(d) {
      return this.onClickMessage(d.row, d.event);
    },
    onDoubleClick(d) {
      return this.onReadMessage(d.row, d.event);
    },

    onReadMessage(el, e) {
      if (el.viewedon) return;
      this.$axios.get(this.url + "/" + el.id);
      this.$store.dispatch("state/badges", this.targetName + "_comments");
    },
    onClickMessage(el, e) {
      console.log("onClickMessage");
      return;
      this.$axios.get(this.url + "/" + el.id);
      setTimeout(() => {
        this.$store.dispatch("state/badges", this.targetName + "_comments");
      }, 500);

      el.viewedon = 1;
    },
    addComment(c) {
      this.target.id = this.id || null;
      this.idEdit = 0;
      this.target.parent = c || null;
      console.log("add", this.id, c, this.target);
      this.showEdit = true;
    },
  },
  directives: {
    intersection: {
      inserted(el, binding) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              binding.value(); // Вызываем переданную функцию
            }
          },
          {
            threshold: 0.1, // Процент видимости элемента (0.1 = 10%)
          }
        );
        observer.observe(el);
      },
      unbind(el) {
        if (el.__vueIntersectionObserver__) {
          el.__vueIntersectionObserver__.disconnect();
        }
      },
    },
  },
};
</script>
<style lang="scss">
.vac-card-date {
  max-width: 150px;
  font-weight: 500;
  //text-transform: uppercase;
  color: rgb(80, 90, 98);
  background-color: rgba(0, 0, 0, 0.1);
  //color: var(--chat-message-color-date);
  //background-color: var(--chat-message-bg-color-date);
}
.vac-card-info {
  border-radius: 4px;
  text-align: center;
  margin: 10px auto;
  font-size: 12px;
  padding: 1px 10px;
  display: block;
  overflow-wrap: break-word;
  position: relative;
  white-space: normal;
  box-shadow: 0 1px 1px -1px #0000001a, 0 1px 1px -1px #0000001c, 0 1px 2px -1px #0000001c;
}
.reply-message-field .v-text-field__slot {
  max-height: 100px;
  overflow-y: hidden; /* Добавьте прокрутку, если содержимое превышает максимальную высоту */
}
</style>
